import React, { useRef, useState } from "react";
import Img_logo from "../../assets/auth/logo.png";
import Reset_Password from "../../assets/auth/reset-password.png";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/client/resetpassword.module.scss";
import { resetClientPasswordService } from "../../services";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { clientLogoutState } from "../../redux";
import { clientRoutes } from "../../routers/ClientRouters";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  let passwordRef = useRef("");
  let confirmPasswordRef = useRef("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const dispatch = useDispatch();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleLogout = async () => {
    dispatch(clientLogoutState());
    navigate(clientRoutes.login);
  };

  const handleConfirmPasswordCheck = () => {
    const password = passwordRef.current?.value;
    const confirmPassword = confirmPasswordRef.current?.value;

    if (confirmPassword && password !== confirmPassword) {
      setPasswordError("Passwords do not match");
    } else if (confirmPassword && password === confirmPassword) {
      setPasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const password = passwordRef.current?.value;
    const confirmPassword = confirmPasswordRef.current?.value;

    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setPasswordError("Password must be at least 6 characters long");
      return;
    }

    const success = await resetClientPasswordService(
      token,
      passwordRef.current?.value
    );

    if (success) {
      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
            <button 
              id="customCloseButton" 
              style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
              <img 
                src=${Close_Button} 
                alt="Close" 
                style="width: 50px; height: 50px;"
              />
            </button>
            <img 
              src=${Reset_Password} 
              alt="Success" 
              style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
            />
            <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Password Changed!</h2>
            <br/>
            <p style="font-family: 'Gotham Book', sans-serif;">
              You've successfully completed your password reset.
            </p>
            <br/>
            <button 
              id="okButton" 
              style="
                background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                color: #f3f3f6; 
                padding: 10px 30px; 
                border: none; 
                border-radius: 5px; 
                cursor: pointer; 
                margin-top: 20px; 
                font-family: 'gothambold', sans-serif;
              ">
              Login Now
            </button>
          </div>
        `,
        showConfirmButton: false,
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const thanksButton = document.getElementById("okButton");
          thanksButton.addEventListener("click", () => {
            Swal.close();
            handleLogout();
            navigate(clientRoutes.login);
          });
        },
      });
    }
  };

  return (
    <div className={Styles.dashboard_main}>
      <div className={Styles.dashboard_flexmain}>
        <div className={Styles.flexdivider_2}>
          <div className={Styles.flexdivider_2_logo}>
            <img src={Img_logo} alt="admin_dash_logo" />
          </div>

          <div className={Styles.flexdivider_2_formcontainer}>
            <form autoComplete="off" onSubmit={handleSubmit}>
              {/* Password Field */}
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.password}>Enter Password</label>
                <div className={Styles.password_input_wrapper}>
                  <input
                    placeholder="Enter password"
                    name="newPassword"
                    minLength={6}
                    maxLength={50}
                    ref={passwordRef}
                    type={showPassword ? "text" : "password"}
                    required
                  />
                  <div
                    onClick={togglePasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>
              </div>

              <br />

              {/* Confirm Password Field */}
              <div className={Styles.flexdivider_2_formcontainer_username}>
                <label className={Styles.password}>Confirm Password</label>
                <div className={Styles.password_input_wrapper}>
                  <input
                    placeholder="Confirm password"
                    name="confirmPassword"
                    minLength={6}
                    maxLength={50}
                    ref={confirmPasswordRef}
                    type={showConfirmPassword ? "text" : "password"}
                    onBlur={handleConfirmPasswordCheck}
                    onChange={handleConfirmPasswordCheck}
                    required
                  />
                  <div
                    onClick={toggleConfirmPasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showConfirmPassword ? pass_on : pass_off}
                      alt="Toggle confirm password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>
              </div>

              {/* Error Message */}
              {passwordError && (
                <div
                  style={{
                    color: "#e27908",
                    fontSize: "14px",
                    marginTop: "10px",
                    textAlign: "center",
                  }}
                >
                  {passwordError}
                </div>
              )}

       
              <br />
              <div className={Styles.flexdivider_2_formcontainer_button}>
                <button type="submit">
                  <span>SUBMIT</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
